import { Boots, ItemRarity } from 'game/core'
import { ItemUI } from 'game/extended/uis/item_uis'

import image from './iced_boots.png'

export const iced_boots: ItemUI<Boots> = {
    image,
    label: 'Iced boots',
    value: 75,
    item: {
        key: 'iced_boots',
        type: 'boots',
        rarity: ItemRarity.Epic,
        stats: {
            intelligence: 50,
            agility: -10,
            resistance: 20
        }
    }
}
